'use client';
import Footer from '@c/footer/Footer';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import Navbar from '../Navbar';
import MainContent from './components/MainContent';
interface NavbarFooterLayoutProps {
  children: ReactNode;
}
export default function NavbarFooterLayout({
  children,
}: NavbarFooterLayoutProps) {
  const pathname = usePathname();
  const excludedNavRoutes = [
    '/login',
    '/signup',
    '/forgot-password',
    '/reset-password',
    '/401',
    '/app/bank-connect',
    '/become-a-seller',
    '/checkout',
    '/affirm',
    '/create-listing',
    '/edit-listing',
    '/order-confirmation',
    '/verify-email',
    '/verify-id',
    '/verify-phone',
    '/embed/',
    '/welcome',
  ];

  const excludedFooterRoutes = [...excludedNavRoutes, '/dashboard/messages'];

  return (
    <div className="w-full overflow-x-hidden">
      {!excludedNavRoutes.some((route) => pathname?.startsWith(route)) && (
        <Navbar />
      )}

      <MainContent>{children}</MainContent>

      {!excludedFooterRoutes.some((route) => pathname?.startsWith(route)) && (
        <Footer />
      )}
    </div>
  );
}
